import styled, { keyframes } from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

type LoaderProps = {
  size: number;
  borderWidth: number;
};

const spinAnimation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const StyledLoader = styled.div<LoaderProps>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border: ${({ borderWidth }) => borderWidth}px solid ${colorsPalettes.midnight[50]};
  border-left-color: transparent;
  border-radius: 50%;
  animation: ${spinAnimation} 1s linear infinite;
  margin: 0 auto;
`;
